import { render } from "./PatientExamTab.vue?vue&type=template&id=31a60592&scoped=true"
import script from "./PatientExamTab.vue?vue&type=script&lang=js"
export * from "./PatientExamTab.vue?vue&type=script&lang=js"

import "./PatientExamTab.vue?vue&type=style&index=0&id=31a60592&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a60592"]])

export default __exports__